import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IntegrationMixin extends Vue {
  get guideLinks(){
    return {
      propeller:`https://docs.bemob.com/${this.$i18n.locale}/propellerads-settings`,
      exoclick:`https://docs.bemob.com/${this.$i18n.locale}/exoclick-settings`,
      mgid:`https://docs.bemob.com/${this.$i18n.locale}/mgid-settings`,
      revcontent:`https://docs.bemob.com/${this.$i18n.locale}/revcontent-settings`,
      facebook:`https://docs.bemob.com/${this.$i18n.locale}/facebook-settings`,
      trafficjunky:`https://docs.bemob.com/${this.$i18n.locale}/trafficjunky-settings`
    }
  }

  get integrationsData(){
    return {
      'propeller':{
        name: 'PropellerAds',
        type: 'propeller',
        accessToken: {
          label: this.t('API Token')+'*',
          labelHelp: this.t('Specify your API key to authenticate the requests of BeMob'),
          placeholder:  this.t('Type Your {0} API Token',['Propellerads']),
        },
        img:{
          src: 'propeller.png',
        },
        guideLink: this.guideLinks.propeller,
        help: this.t('Follow these steps to integrate BeMob with PropellerAds for automatic cost collection: <br>- specify the custom name for integration. The name is limited to 255 alphanumeric characters.<br>- copy your API key from PropellerAds account. For this log into <a href="{0}">PropellerAds</a> and select <b>API access</b> in <b>Personal</b> details at the top of the panel.<br>- return to your BeMob settings and paste the copied key value.<br>- click on <b>Create Integration</b>.<br>More details find in our dedicated <a href="{1}">guide</a>.',['https://partners.propellerads.com/#/app/auth',this.guideLinks.propeller]),
      },
      'exoclick':{
        name: 'ExoClick',
        type: 'exoclick',
        accessToken: {
          label:this.t('API Token')+'*',
          labelHelp: this.t('Specify your API key to authenticate the requests of BeMob'),
          placeholder: this.t('Type Your {0} API Token',['ExoClick']),
        },
        img:{
          src: 'ex-oclick.svg',
          style: {
            height:'20px',
            'margin-top':' -3px'
          }
        },
        guideLink: this.guideLinks.exoclick,
        help: this.t('Follow these steps to integrate BeMob with ExoClick for automatic cost collection: <br>- specify the custom name for integration. The name is limited to 255 alphanumeric characters.<br>- copy your API key from ExoClick account. For this log into <a href="{0}">ExoClick</a> and access Profile settings at the top of the panel and select API Tokens.<br>- return to your BeMob settings and paste the copied key value.<br>- click on Create Integration.<br>More details find in our dedicated <a href="{1}">guide</a>.',['https://admin.exoclick.com/login',this.guideLinks.exoclick]),
      },
      'mgid':{
        name: 'MGID',
        type: 'mgid',
        clientId: {
          label:`${this.t('Client ID')} (${this.t('API ID')})*`,
          placeholder: this.t('API ID'),
        },
        accessToken: {
          label:this.t('API Token')+'*',
          labelHelp: this.t('Specify your API key to authenticate the requests of BeMob'),
          placeholder:  this.t('Enter the MGID access token'),
        },
        img:{
          src: 'mgid.svg',
          style: {
            height:'34px'
          }
        },
        guideLink: this.guideLinks.mgid,
        help:this.t('Follow these steps to integrate BeMob with MGID for automatic cost collection: <br>- specify the custom name for integration. The name is limited to 255 alphanumeric characters.<br>- copy your API key from MGID account. For this log into <a href="{0}">MGID account</a> and go to <b>My Profile</b> → <b>Users</b> →<b>Get your token</b>.<br>- return to your BeMob settings and paste the copied key value.<br>- click on <b>Create Integration</b>.<br>More details find in our dedicated <a href="{1}">guide</a>.',['https://dashboard.mgid.com/user/signin',this.guideLinks.mgid]),
      },
      'revcontent':{
        name: 'Revcontent',
        type: 'revcontent',
        clientId: {
          label:this.t('Client ID')+'*',
          placeholder: this.t('Client ID'),
        },
        accessToken: {
          label:this.t('API Token')+'*',
          labelHelp: this.t('Specify your API key to authenticate the requests of BeMob'),
          placeholder: this.t('Type Your {0} API Token',['Revcontent']),
        },
        img:{
          src: 'revc-ontent.svg',
          style: {
            height:'20px'
          }
        },
        guideLink: this.guideLinks.revcontent,
        help:this.t('Follow these steps to integrate BeMob with Revcontent for automatic cost collection: <br>- specify the custom name for integration. The name is limited to 255 alphanumeric characters.<br>- copy your API key from Revcontent account. For this log into <a href="{0}">Revcontent</a> and request the API access from the support.<br>After that access the Account Settings and scroll down to see the API key<br>- return to your BeMob settings and paste the copied key value.<br>- click on <b>Create Integration</b>.<br>More details find in our dedicated <a href="{1}">guide</a>.',['https://www.revcontent.com/login',this.guideLinks.revcontent]),
      },
      'facebook-conversions':{
        name: 'Facebook',
        type: 'facebook-conversions',
        clientId: {
          label:`${this.t('Client ID')} (${this.t('Pixel ID')})*`,
          labelHelp:this.t('Access your Facebook Pixel\'s setting page → Details section → copy pixel ID'),
          placeholder: this.t('Specify your Facebook Pixel ID'),
        },
        accessToken: {
          label:this.t('API Key')+'*',
          placeholder: this.t('Enter your Facebook API Key'),
          labelHelp:this.t('Go to Facebook Pixel settings → scroll down to the Conversion API section →  click the Generate Access Token within Set up manually section')
        },
        img:{
          src: 'facebook.svg',
          style: {
            height:'20px'
          }
        },
        guideLink: this.guideLinks.facebook,
        help:this.t('With this integration enabled the conversions data will be passed to Facebook side.<br>Follow these steps to set up the integration:<br>1. Specify the custom integration name. The integration will be displayed with this name in Traffic Source settings.<br>2. Find and copy your Pixel ID and Conversion API token on the side of Facebook.<br>3. Specify them in the corresponding fields below.<br>4. Verify your domain on the side of Facebook.<br>5. Paste it in the <b>Event Source URL</b> field.<br>6. Click the <b>Create Integration</b> button.<br>7. If credentials are correct, the settings will be saved.<br>8. Go to the <b>Traffic Source</b> tab to select <b>Facebook</b> in the Integration section.<br><a href={0} target="_blank">Check our step-by-step guide to learn more.</a>',[`https://docs.bemob.com/${this.$i18n.locale}/facebook-settings`]),
      },
      'trafficjunky':{
        name: 'TrafficJunky',
        type: 'trafficjunky',
        accessToken: {
          label: this.t('API Token')+'*',
          labelHelp: this.t('Specify your API key to authenticate the requests from BeMob.'),
          placeholder:  this.t('Type Your TrafficJunky Token'),
        },
        img:{
          src: 'trafficjunky.svg',
        },
        guideLink: this.guideLinks.trafficjunky,
        help: this.t('Follow these steps to integrate BeMob with <b>TrafficJunky</b> for automatic cost collection: <br>- specify the custom name for integration. The name is limited to 255 alphanumeric characters.<br>- copy your API key from <b>TrafficJunky</b>. For this log into <a href="{0}">TrafficJunky account</a> and click on <b>Generate New Token</b> in <b>My Profile</b> settings in the bottom left corner of the panel. <br>- return to your BeMob settings and paste the copied key value.<br>- click on <b>Create Integration</b>.<br>More details find in our dedicated <a href="{1}">guide</a>.',['https://advertiser.trafficjunky.com/my-profile-account',this.guideLinks.trafficjunky]),
      },
    }as {[type: string]: Integration}
  }
} 
